import _ from 'lodash';
import { createSelector } from 'reselect';

import * as MassActionFeedbackChannel from 'app/entities/MassActionFeedbackChannel';
import { HELD_STALE_AUTH_ID } from 'app/history/utils/constants';

export const selectTasks = state => _.get(state.taskHistory, ['tasks'], []);

export const selectNumberOfReplayableTasks = state =>
  state.numberOfReplayableTasks;

export const selectTasksLoadedTimestamp = state => state.tasksLoadedTimestamp;

export const selectDeletedTasks = createSelector(
  selectTasks,
  MassActionFeedbackChannel.selectors.all.taskReplayChannel,
  (tasks, channel) => {
    if (!channel) {
      return [];
    }
    return tasks.filter(task =>
      MassActionFeedbackChannel.selectors.isDeleted(task.id, channel)
    );
  }
);

const selectDeletedTaskIds = state => state.taskHistory.deletedTaskIds;

export const selectIsMarkedDeleted = (taskId, state) =>
  _.includes(selectDeletedTaskIds(state), taskId);

export const selectSelectedTasks = state =>
  _.get(state.taskHistory, ['selectedTasks']);

export const selectIsStartingMassAction = state =>
  _.get(state.taskHistory, ['isStartingMassAction']);

export const selectStaleAuthIds = createSelector(selectTasks, tasks =>
  _.compact(_.map(tasks, HELD_STALE_AUTH_ID))
);

export const selectIsAllTasksSelected = state => state.isAllTasksSelected;

export const selectLimit = state => state.limit;
